import { Profile } from '../../common/models/Profile';
import { User } from './User';

export class Project {
  constructor(
    private readonly id: number,
    private readonly name: string,
    private readonly description: string | null,
    private readonly defaultProfile: Profile | null,
    private readonly maxItemCount: number | null,
    private readonly testers: User[]
  ) {}

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getDefaultProfile() {
    return this.defaultProfile;
  }

  getMaxItemCount(): number {
    return this.maxItemCount ?? 0;
  }

  getTesters() {
    return this.testers;
  }
}
